import { FlexBoxHorizontal } from "common/base/flex-box";
import { TrophyIcon } from "common/svg";
import { SocialShare } from "dashboard/ui/pages/Progress/SocialShare";
import { FC } from "react";
import { AppButton } from "site/ui";
import { useQuizStore } from "store";
import styled from "styled-components";
import { IQuizYear, IUserQuiz } from "utils/types";

const ResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 24px 0;
  font-family: "Manrope", sans-serif;
  gap: 20px;
`;
const Score = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: #111827;
`;

const ScoreDescription = styled.p`
  font-size: 14px;
  color: #6b7280;
`;

const ExamName = styled.p`
  font-size: 16px;
  font-weight: 500;
  color: #111827;
`;

export interface QuizCompleteStateProps {
    onShare: (data: { userQuiz: IUserQuiz, quiz: IQuizYear}) => void;
}

export const QuizCompleteState:FC<QuizCompleteStateProps> = ({
    onShare
}) => {
    const { userQuiz, quiz, setQuizState } = useQuizStore()
    return (
        <ResultContainer>
          <Score>You scored {userQuiz?.score || 0} / {userQuiz?.totalScore || 0}</Score>
          <ScoreDescription>
            {userQuiz?.remark}
          </ScoreDescription>
          <TrophyIcon fontSize={14} height={100} width={100}/>

          <ExamName>
            {quiz?.quizYear || ""}
          </ExamName>
          <FlexBoxHorizontal>

            <AppButton
              variant="secondary"
              style={{ marginTop: "12px" }}
              onClick={() => setQuizState("reportCard")}
              >
              View report summary
            </AppButton>
          </FlexBoxHorizontal>
          <SocialShare/>
        </ResultContainer>
      );
}